/*eslint-disable*/
import { createHttpClient } from '@fil-global/eiswagen';
import RiskMinder from '@fil-global/fil-lib-riskminder';
import API_CONFIG from './API-config.json';
import { Modal, Button, Notification, Paragraph } from '@fil-global/eiswurfel';
const ENV_LOCAL = 'LOCAL';
const ENV_DEV = 'DEV';
const ENV_SIT = 'SIT';
const ENV_DEV1 = 'DEV1';
const ENV_SIT1 = 'SIT1';
const ENV_EBF1 = 'EBF1';
const ENV_UAT = 'UAT';
const ENV_PROD = 'PROD';
const ENV_FDC1 = 'FDC1';
const ENV_FDC3 = 'FDC3';
const hostname = window.location.hostname;
export const getEnvironment = host => {
  switch (host) {
    case 'localhost':
    case '127.0.0.1':
      return ENV_LOCAL;
    case 'dev.fidelityviewnp.com':
      return ENV_DEV;
    case 'dev1.fidelityviewnp.com':
        return ENV_DEV1;
    case 'sit.fidelityviewnp.com':
      return ENV_SIT;
    case 'sit1.fidelityviewnp.com':
      return ENV_SIT1;
    case 'ebf1.fidelityviewnp.com':
      return ENV_EBF1;
    case 'www.fidelityviewnp.com':
      return ENV_UAT;
    case 'www.fidelityview.com':
      return ENV_PROD;
    case 'beta.fidelityview.com':
      return ENV_PROD;
    case 'fdc1.fidelityview.com':
      return ENV_FDC1;
    case 'fdc3.fidelityview.com':
      return ENV_FDC3;
    default:
      throw new Error('Unknown environment: ' + host);
  }
};
const axiosConfig = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_PS_LAYER7,
  timeout: 100000,
  withCredentials: true,
};
const axiosConfigRP = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_RP_LAYER7,
  timeout: 100000,
  withCredentials: true,
};
const axiosConfigEmail = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_HELP_EMAIL,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigUM = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_UM_LAYER7,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigUMBlock = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_UM_LAYER7_BLOCK,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigUMAPI = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_UM_LAYER7_API,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigLocalHost = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_LOCALHOST,
  timeout: 100000,
};

const axiosS3config = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_AMAZONS3,
  timeout: 100000,
};

const axiosConfigLayer7Gateway = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_LAYER7,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigLayer7API = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_LAYER7_INTERNAL,
  // 'https://sit-api.fidelityviewnp.com:15012/api/fv/iam/v1/',
  // API_CONFIG[getEnvironment(hostname)].REACT_APP_LAYER7_INTERNAL,
  timeout: 100000,
  withCredentials: true,
};

const axiosClientSSOLayer7API = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_SSO_LAYER7,
  // 'https://apigateway-sit.uk.fid-intl.com:17012/api/fv/iam/v1/',
  // API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_SSO_LAYER7,
  timeout: 100000,
  withCredentials: true,
};

const axiosDevAPITest = {
  host: 'https://dev-api.fidelity.co.uk:15012',
  // 'https://apigateway-sit.uk.fid-intl.com:17012/api/fv/iam/v1/',
  // API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_SSO_LAYER7,
  timeout: 100000,
  withCredentials: true,
};

const axiosConfigRolesUM = {
  // host: 'https://apigateway-sit.uk.fid-intl.com:17012/gateway/fv/roles/v1/',
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_FV_UM_ROLES_LAYER7,
  timeout: 100000,
  withCredentials: true,
};

const axiosAwsEmailReportconfig = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_AWS_REPORT_EMAIL,
  timeout: 100000,
  withCredentials: true,
};

const axiosPingHandlerConfig = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_API_PING_HANDLER,
  timeout: 100000,
  withCredentials: true,
  crossDomain: true,
};

const axiosPingSessionConfig = {
  host: API_CONFIG[getEnvironment(hostname)].REACT_APP_API_PING_SESSION,
  timeout: 100000,
  withCredentials: true,
};



const axiosClient = createHttpClient(axiosConfig);
const axiosClientRP = createHttpClient(axiosConfigRP);
const axiosClientUM = createHttpClient(axiosConfigUM);
const axiosClientUMBlock = createHttpClient(axiosConfigUMBlock);
const axiosClientEmail = createHttpClient(axiosConfigEmail);
const axiosLayer7Client = createHttpClient(axiosConfigLayer7Gateway);
const axiosLayer7ClientAPI = createHttpClient(axiosConfigLayer7API);
const axiosClientLocalHost = createHttpClient(axiosConfigLocalHost);
const axiosClientAmaznS3 = createHttpClient(axiosS3config);
const axiosSSOLayer7Client = createHttpClient(axiosClientSSOLayer7API);
const axiosDevClientTest = createHttpClient(axiosDevAPITest);
const axiosClientRolesUM = createHttpClient(axiosConfigRolesUM);
const axiosClientAwsEmailReport = createHttpClient(axiosAwsEmailReportconfig);
const axiosClientUMAPI = createHttpClient(axiosConfigUMAPI);
const axiosPingHandlerClient = createHttpClient(axiosPingHandlerConfig);
const axiosPingSessionClient = createHttpClient(axiosPingSessionConfig);

const mfp = JSON.stringify(RiskMinder.getMFPasJSON());
axiosLayer7Client.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      navigationPath: window.location.hash.replace('#', ''),
      selectedScheme: sessionStorage.getItem('selectedSchemeTracking'),
    };
    if(config.url==='register'){
      config.headers.region = sessionStorage.getItem('region');
    }
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosClientUM.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      navigationPath: window.location.hash.replace('#', ''),
      selectedScheme: sessionStorage.getItem('selectedSchemeTracking'),
    };
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosLayer7ClientAPI.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      navigationPath: window.location.hash.replace('#', ''),
      selectedScheme: sessionStorage.getItem('selectedSchemeTracking'),
    };
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosSSOLayer7Client.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
    };
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosClient.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      navigationPath: window.location.hash.replace('#', ''),
      selectedScheme: checkSelectedSchemeForFundDashboard(config.url),
    };
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosClientRP.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      selectedScheme: sessionStorage.getItem('selectedSchemeTracking'),
      navigationPath: window.location.hash.replace('#', ''),
    };

    return config; // Important to return it
  },
  error => {
    return Promise.reject(error);
  }
);

axiosClientRP.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosClientUM.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosClientUMAPI.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      navigationPath: window.location.hash.replace('#', ''),
      selectedScheme: sessionStorage.getItem('selectedSchemeTracking'),
    };
    return config; // Important to return it
  },
  error => Promise.reject(error)
);

axiosClientUMAPI.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosLayer7Client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 406)) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosLayer7ClientAPI.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

axiosClientRolesUM.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401 || error.response.status === 406) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

// axiosClientAwsEmailReport.interceptors.request.use(
//   config => {
//     config.headers = {
//       ...config.headers,
//       'x-api-key': API_CONFIG[getEnvironment(hostname)].SEND_EMAIL_API_KEY,
//     };
//     return config; // Important to return it
//   },
//   error => Promise.reject(error)
// );

axiosClientAwsEmailReport.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error);
    console.log(error.response);
    console.log(error.response.status);
    if (error.response.status === 403 || error.response.status === 401) {
      sessionStorage.setItem('sessionTimeOutCode', error.response.status);
      window.location.hash = '/sessiontimeout';
    }
    return Promise.reject(error);
  }
);

function checkSelectedSchemeForFundDashboard(urlstring){
  let pattern = /^fundperformance\/holding\?/;
  if(pattern.test(urlstring) && (sessionStorage.getItem('selectedSchemeTracking') === null || sessionStorage.getItem('selectedSchemeTracking')!=null && sessionStorage.getItem('selectedSchemeTracking').length === 0)){
    return null;
  }
  else{
    return sessionStorage.getItem('selectedSchemeTracking');
  }
}

export {
  axiosClient,
  axiosClientLocalHost,
  axiosLayer7Client,
  axiosLayer7ClientAPI,
  axiosClientAmaznS3,
  axiosClientUM,
  axiosClientUMBlock,
  axiosClientRP,
  axiosClientEmail,
  axiosSSOLayer7Client,
  axiosDevClientTest,
  axiosClientRolesUM,
  axiosClientAwsEmailReport,
  axiosClientUMAPI,
  axiosPingHandlerClient,
  axiosPingSessionClient,
};
